<template>
  <div
      :class="panel ? 'cp-bar cp-bar--hue' : 'hue'"
      @mousedown.prevent.stop="selectHue"
  >
    <canvas ref="canvasHue" />
    <div
        :style="slideHueStyle"
        :class="panel ? 'cp-bar__thumb' : 'slide'"
    />
  </div>
</template>

<script>
const PANEL_WIDTH  = 360;
const PANEL_HEIGHT = 10;

export default {
  props: {
    hsv: {
      type:    Object,
      default: null,
    },
    width: {
      type:    Number,
      default: 25,
    },
    height: {
      type:    Number,
      default: 152,
    },
    panel: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return { slideHueStyle2: {} };
  },
  computed: {
    slideHueStyle() {
      if (this.panel) {
        return { left: `${(this.hsv.h / 360) * 100}%` };
      }
      let top = Math.max(0, Math.floor((1 - this.hsv.h / 360) * this.height));
      top     = Math.min(this.height - 6, top);
      return { top: `${top}px` };
    },
  },

  mounted() {
    this.renderColor();
    // this.renderSlide();
  },
  methods: {
    renderSlide() {},
    renderColor() {
      if (this.panel) {
        this.renderPanelColor();
        return;
      }
      const canvas  = this.$refs.canvasHue;
      const width   = this.width;
      const height  = this.height;
      const ctx     = canvas.getContext('2d');
      canvas.width  = width;
      canvas.height = height;

      const gradient = ctx.createLinearGradient(0, 0, 0, height);
      gradient.addColorStop(0, '#FF0000');
      gradient.addColorStop(0.17 * 1, '#FF00FF');
      gradient.addColorStop(0.17 * 2, '#0000FF');
      gradient.addColorStop(0.17 * 3, '#00FFFF');
      gradient.addColorStop(0.17 * 4, '#00FF00');
      gradient.addColorStop(0.17 * 5, '#FFFF00');
      gradient.addColorStop(1, '#FF0000');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
    },
    renderPanelColor() {
      const canvas  = this.$refs.canvasHue;
      const ctx     = canvas.getContext('2d');
      canvas.width  = PANEL_WIDTH;
      canvas.height = PANEL_HEIGHT;

      const gradient = ctx.createLinearGradient(0, 0, PANEL_WIDTH, 0);
      gradient.addColorStop(0, '#FF0000');
      gradient.addColorStop(0.17 * 1, '#FFFF00');
      gradient.addColorStop(0.17 * 2, '#00FF00');
      gradient.addColorStop(0.17 * 3, '#00FFFF');
      gradient.addColorStop(0.17 * 4, '#0000FF');
      gradient.addColorStop(0.17 * 5, '#FF00FF');
      gradient.addColorStop(1, '#FF0000');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, PANEL_WIDTH, PANEL_HEIGHT);
    },
    selectHue(e) {
      if (this.panel) {
        this.selectPanelHue(e);
        return;
      }
      const { top: hueTop } = this.$el.getBoundingClientRect();
      const ctx             = e.target.getContext('2d');

      const mousemove = (e) => {
        let y = e.clientY - hueTop;

        if (y < 0) {
          y = 0;
        }
        if (y > this.height) {
          y = this.height;
        }
        const topvalue = Math.max(0, y - 5);

        this.slideHueStyle = { top: `${topvalue}px` };
        const imgData      = ctx.getImageData(0, Math.min(y, this.height - 1), 1, 1);
        const [r, g, b]    = imgData.data;
        this.$emit('selectHue', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
    selectPanelHue(e) {
      const rect = this.$el.getBoundingClientRect();
      const ctx  = this.$refs.canvasHue.getContext('2d');

      const mousemove = (event) => {
        const fx = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        const x         = Math.min(Math.floor(fx * PANEL_WIDTH), PANEL_WIDTH - 2);
        const imgData   = ctx.getImageData(x, Math.floor(PANEL_HEIGHT / 2), 1, 1);
        const [r, g, b] = imgData.data;
        this.$emit('selectHue', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>

<style lang="scss">

</style>
